(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["badwolfmegahome"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('badwolf-home')) {
 class BadwolfHome extends HTMLElement {
  connectedCallback() {
   if (this.started) return;
   this.started = true;
   this.abort = new AbortController();
   this.quickSequence = 0;
   this.cartSequence = 0;
   this.busy = false;
   this.rootPath = (this.dataset.root || '/').replace(/\/?$/, '/');
   this.currency = this.dataset.currency || 'MXN';
   this.addEventListener('click', this.onClick.bind(this), {signal:this.abort.signal});
   this.addEventListener('close', () => this.restoreFocus(), {capture:true,signal:this.abort.signal});
   document.addEventListener('click', e => {if (!e.composedPath().includes(this.querySelector('.bw-nav'))) this.querySelectorAll('.bw-nav details[open]').forEach(d=>d.open=false);}, {signal:this.abort.signal});
   this.querySelectorAll('dialog').forEach(d => d.addEventListener('click', e => {if(e.target===d){const r=d.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)d.close();}}, {signal:this.abort.signal}));
   this.syncNativeChrome();
   this.chromeObserver = new MutationObserver(() => this.syncNativeChrome());
   this.chromeObserver.observe(document.body,{childList:true,subtree:true});
   this.startIntro();
   this.querySelectorAll('video').forEach(v=>{v.muted=true;if(matchMedia('(prefers-reduced-motion: reduce)').matches){v.pause();const b=this.querySelector('[data-video-toggle]');if(b){b.textContent='Reproducir';b.setAttribute('aria-label','Reproducir video');}}});
  }
  disconnectedCallback(){this.chromeObserver?.disconnect();this.releaseNativeChrome();this.abort?.abort();this.quickSequence++;this.cartSequence++;clearTimeout(this.introTimer);clearTimeout(this.statusTimer);this.querySelectorAll('dialog[open]').forEach(d=>d.close());this.started=false;}
  nativeChromeNodes(){return [...document.querySelectorAll('.shopify-section-group-header-group,.shopify-section-group-footer-group,#shopify-section-header,#shopify-section-footer,#header-group,#footer-group')].filter(n=>!n.contains(this)&&!n.closest('badwolf-home'));}
  syncNativeChrome(){if(!this.isConnected)return;this.nativeChromeNodes().forEach(n=>{if(!n.hasAttribute('data-bw-native-hidden')){n.setAttribute('data-bw-native-hidden','');n.dataset.bwPreviousDisplay=n.style.getPropertyValue('display');n.dataset.bwPreviousPriority=n.style.getPropertyPriority('display');}if(n.style.getPropertyValue('display')!=='none'||n.style.getPropertyPriority('display')!=='important')n.style.setProperty('display','none','important');});}
  releaseNativeChrome(){if(document.querySelector('badwolf-home[data-replace-chrome="true"]'))return;document.querySelectorAll('[data-bw-native-hidden]').forEach(n=>{const v=n.dataset.bwPreviousDisplay,p=n.dataset.bwPreviousPriority;if(v)n.style.setProperty('display',v,p);else n.style.removeProperty('display');n.removeAttribute('data-bw-native-hidden');delete n.dataset.bwPreviousDisplay;delete n.dataset.bwPreviousPriority;});}
  startIntro(){const el=this.querySelector('.bw-intro');if(!el||this.dataset.intro!=='true'||this.dataset.designMode==='true'||matchMedia('(prefers-reduced-motion: reduce)').matches)return;try{if(sessionStorage.getItem('badwolf-entry-v1'))return;sessionStorage.setItem('badwolf-entry-v1','1');}catch(e){}el.classList.add('is-active');this.introTimer=setTimeout(()=>el.classList.remove('is-active'),1250);}
  escape(value){return String(value??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));}
  money(cents){try{return new Intl.NumberFormat('es-MX',{style:'currency',currency:this.currency,maximumFractionDigits:2}).format(Number(cents)/100);}catch(e){return '$'+(Number(cents)/100).toFixed(2);}}
  async request(path,body){if(this.dataset.visual==='true'&&body)throw new Error('Esta colección visual se consulta en Badwolf.');const response=await fetch(this.rootPath+path,{method:body?'POST':'GET',headers:{'Accept':'application/json',...(body?{'Content-Type':'application/json'}:{})},credentials:'same-origin',signal:this.abort.signal,...(body?{body:JSON.stringify(body)}:{})});let data;try{data=await response.json();}catch(e){throw new Error('No pudimos conectar con la tienda. Intenta de nuevo.');}if(!response.ok)throw new Error(typeof data.description==='string'?data.description:typeof data.message==='string'?data.message:'No se pudo completar la solicitud.');return data;}
  open(name,trigger){if(this.dataset.visual==='true'&&name==='cart'){window.location.href='https://badwolfmx.com/cart';return;}const dialog=this.querySelector('[data-dialog="'+name+'"]');if(!dialog)return;this.querySelectorAll('dialog[open]').forEach(d=>d.close());this.lastFocus=trigger||document.activeElement;dialog.showModal();if(name==='search')dialog.querySelector('input[type=search]')?.focus();if(name==='cart')this.loadCart();}
  restoreFocus(){if(!this.querySelector('dialog[open]')&&this.lastFocus?.isConnected)this.lastFocus.focus({preventScroll:true});}
  status(text){const node=this.querySelector('[data-status]');if(!node)return;node.textContent=text;node.classList.add('is-visible');clearTimeout(this.statusTimer);this.statusTimer=setTimeout(()=>node.classList.remove('is-visible'),4500);}
  async onClick(e){
   const t=e.target.closest('button,a');if(!t||!this.contains(t))return;
   if(t.hasAttribute('data-open')){e.preventDefault();this.open(t.dataset.open,t);return;}
   if(t.hasAttribute('data-close')){t.closest('dialog')?.close();return;}
   if(t.hasAttribute('data-quick')){this.open('quick',t);this.loadProduct(t.dataset.quick);return;}
   if(t.hasAttribute('data-option')){this.selection[Number(t.dataset.option)]=t.dataset.value;this.chosenSelections.add(Number(t.dataset.option));this.updateVariant();return;}
   if(t.hasAttribute('data-add')){this.addProduct(t);return;}
   if(t.hasAttribute('data-cart-key')){this.changeQuantity(t.dataset.cartKey,Number(t.dataset.quantity));return;}
   if(t.hasAttribute('data-scroll')){const track=t.closest('section').querySelector('[data-scroll-track]');track?.scrollBy({left:track.clientWidth*(t.dataset.scroll==='next'?1:-1),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});return;}
   if(t.hasAttribute('data-video-toggle')){const video=this.querySelector('.bw-hero-video');if(!video)return;if(video.paused){try{await video.play();t.textContent='Pausar';t.setAttribute('aria-label','Pausar video');}catch(err){this.status('No fue posible reproducir el video.');}}else{video.pause();t.textContent='Reproducir';t.setAttribute('aria-label','Reproducir video');}}
  }
  async loadProduct(handle){if(this.dataset.visual==='true'){window.location.href='https://badwolfmx.com/products/'+encodeURIComponent(handle);return;}
   const sequence=++this.quickSequence;
   const node=this.querySelector('[data-quick-body]');
   node.innerHTML='<p class="bw-loading" role="status">Cargando producto…</p>';
   try{
    const product=await this.request('products/'+encodeURIComponent(handle)+'.js');
    if(sequence!==this.quickSequence||!this.isConnected)return;
    this.product=product;
    const first=product.variants.find(v=>v.available)||product.variants[0];
    this.selection=first?first.options.slice():[];
    const options=product.options.map((option,index)=>typeof option==='string'?{name:option,values:[...new Set(product.variants.map(v=>v.options[index]))]}:option);
    this.requiredSelections=new Set(options.map((o,i)=>o.values.length>1?i:-1).filter(i=>i>=0));
    this.chosenSelections=new Set();
    const esc=this.escape.bind(this);
    const image=first?.featured_image?.src||product.featured_image||product.images[0]||'';
    node.innerHTML=(image?'<img class="bw-quick-photo" data-variant-image src="'+esc(image)+'" alt="'+esc(product.title)+'" width="450" height="560">':'<div></div>')+'<div class="bw-quick-detail"><h2>'+esc(product.title)+'</h2><p class="bw-quick-price" data-variant-price></p>'+options.map((opt,i)=>'<fieldset><legend>'+esc(opt.name)+'</legend><div class="bw-option-values">'+opt.values.map(v=>'<button type="button" data-option="'+i+'" data-value="'+esc(v)+'" aria-pressed="false">'+esc(v==='Default Title'?'Única':v)+'</button>').join('')+'</div></fieldset>').join('')+'<p class="bw-quick-note" data-variant-note></p><button class="bw-btn" type="button" data-add>Agregar al carrito</button><p class="bw-quick-error" data-quick-error role="alert"></p><a href="'+this.rootPath+'products/'+encodeURIComponent(handle)+'">Ver todos los detalles</a></div>';
    this.updateVariant();
   }catch(err){if(err.name==='AbortError'||sequence!==this.quickSequence||!this.isConnected)return;node.innerHTML='<div class="bw-loading"><p>'+this.escape(err.message)+'</p><a class="bw-text-link" href="'+this.rootPath+'products/'+encodeURIComponent(handle)+'">Abrir producto</a></div>';}
  }
  updateVariant(){
   if(!this.product)return;
   this.variant=this.product.variants.find(v=>v.options.every((value,index)=>value===this.selection[index]));
   this.selectionReady=[...this.requiredSelections].every(i=>this.chosenSelections.has(i));
   this.querySelectorAll('[data-option]').forEach(b=>{const i=Number(b.dataset.option);b.setAttribute('aria-pressed',String((!this.requiredSelections.has(i)||this.chosenSelections.has(i))&&this.selection[i]===b.dataset.value));});
   const button=this.querySelector('[data-add]'),price=this.querySelector('[data-variant-price]'),note=this.querySelector('[data-variant-note]');
   if(!button)return;
   button.disabled=!this.selectionReady||!this.variant?.available||this.busy;
   button.textContent=!this.selectionReady?'Elige tus opciones':!this.variant?'Combinación no disponible':!this.variant.available?'Agotado':'Agregar al carrito';
   price.textContent=this.variant?this.money(this.variant.price):'';
   note.textContent=!this.selectionReady?'Selecciona tu talla y las opciones disponibles.':!this.variant?'Elige otra combinación de opciones.':this.variant.available?'Talla seleccionada: '+this.selection.filter(s=>s!=='Default Title').join(' / '):'Esta opción no está disponible.';
   const image=this.querySelector('[data-variant-image]');if(image&&this.variant?.featured_image?.src)image.src=this.variant.featured_image.src;
  }
  async addProduct(button){
   if(this.busy||!this.selectionReady||!this.variant?.available)return;
   this.busy=true;button.disabled=true;button.textContent='Agregando…';
   const error=this.querySelector('[data-quick-error]');error.textContent='';
   try{await this.request('cart/add.js',{items:[{id:this.variant.id,quantity:1}]});this.open('cart',this.lastFocus);this.status('Agregado a tu carrito.');document.dispatchEvent(new CustomEvent('cart:refresh',{detail:{source:'badwolf'}}));}
   catch(err){if(err.name!=='AbortError')error.textContent=err.message;}
   finally{this.busy=false;this.updateVariant();}
  }
  async loadCart(){
   const sequence=++this.cartSequence,node=this.querySelector('[data-cart-body]');
   node.innerHTML='<p class="bw-loading" role="status">Actualizando carrito…</p>';
   this.querySelector('[data-cart-bottom]').hidden=true;
   this.querySelector('[data-cart-error]').textContent='';
   try{const cart=await this.request('cart.js');if(sequence!==this.cartSequence||!this.isConnected)return;this.renderCart(cart);}
   catch(err){if(err.name==='AbortError'||sequence!==this.cartSequence||!this.isConnected)return;node.innerHTML='<div class="bw-loading"><p>'+this.escape(err.message)+'</p><a class="bw-btn" href="'+this.rootPath+'cart">Abrir carrito</a></div>';}
  }
  renderCart(cart){
   const esc=this.escape.bind(this);this.cart=cart;this.currency=cart.currency||this.currency;
   this.querySelectorAll('[data-cart-count]').forEach(n=>n.textContent=cart.item_count);
   const node=this.querySelector('[data-cart-body]');
   this.querySelector('[data-cart-bottom]').hidden=!cart.item_count;
   this.querySelector('[data-cart-total]').textContent=this.money(cart.total_price);
   if(!cart.item_count){node.innerHTML='<div class="bw-cart-empty"><h2>Tu próximo Badwolf te espera.</h2><p>Elige una prenda y hazla parte de tu rutina.</p><button type="button" class="bw-btn" data-close>Seguir explorando</button></div>';return;}
   node.innerHTML=cart.items.map(item=>'<article class="bw-cart-item">'+(item.image?'<a href="'+esc(item.url)+'"><img src="'+esc(item.image)+'" alt="'+esc(item.product_title)+'" width="85" height="110"></a>':'<div></div>')+'<div><a class="bw-cart-item-title" href="'+esc(item.url)+'">'+esc(item.product_title)+'</a><p class="bw-cart-item-variant">'+esc(item.variant_title==='Default Title'?'':item.variant_title)+'</p><div class="bw-cart-item-bottom"><div class="bw-qty"><button type="button" data-cart-key="'+esc(item.key)+'" data-quantity="'+Math.max(0,item.quantity-1)+'" aria-label="Quitar una unidad de '+esc(item.product_title)+'">−</button><span aria-label="Cantidad">'+item.quantity+'</span><button type="button" data-cart-key="'+esc(item.key)+'" data-quantity="'+(item.quantity+1)+'" aria-label="Agregar una unidad de '+esc(item.product_title)+'">+</button></div><span class="bw-cart-item-price">'+this.money(item.final_line_price)+'</span></div><button type="button" class="bw-cart-remove" data-cart-key="'+esc(item.key)+'" data-quantity="0">Eliminar</button></div></article>').join('');
  }
  async changeQuantity(key,quantity){
   if(this.cartBusy)return;this.cartBusy=true;
   this.querySelectorAll('[data-cart-key]').forEach(b=>b.disabled=true);
   this.querySelector('[data-cart-error]').textContent='';
   try{const cart=await this.request('cart/change.js',{id:key,quantity});this.renderCart(cart);document.dispatchEvent(new CustomEvent('cart:refresh',{detail:{source:'badwolf'}}));}
   catch(err){if(err.name!=='AbortError')this.querySelector('[data-cart-error]').textContent=err.message;}
   finally{this.cartBusy=false;this.querySelectorAll('[data-cart-key]').forEach(b=>b.disabled=false);}
  }
 }
 customElements.define('badwolf-home',BadwolfHome);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hello-ultimate-packages"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('hello-web-form')) return;
  customElements.define('hello-web-form', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const form = this.querySelector('[data-project-form]');
      if (!form) return;
      const field = name => form.elements.namedItem(name);
      const volume = field('volume');
      const packages = new Map([...this.querySelectorAll('[data-package]')].map(el => [el.dataset.package, el.dataset]));
      const error = this.querySelector('[data-error]');
      const button = this.querySelector('[data-submit]');
      const rawPhone = (this.dataset.phone || '').trim();
      const phone = /^[+\d\s().-]+$/.test(rawPhone) ? rawPhone.replace(/\D/g, '') : '';
      const validPhone = /^[1-9]\d{6,14}$/.test(phone);
      const selected = () => packages.get(field('project').value === 'commerce' ? volume.value : field('project').value);
      const clean = value => value.trim().replace(/[\u0000-\u001f\u007f]/g, ' ');
      const update = () => {
        const commerce = field('project').value === 'commerce';
        this.querySelector('[data-volume-wrap]').hidden = !commerce;
        volume.disabled = !commerce;
        volume.required = commerce;
        const item = selected();
        this.querySelector('[data-price]').textContent = item?.price || 'Por definir';
        this.querySelector('[data-time]').textContent = item?.time || 'Por definir';
        this.querySelector('[data-estimate-description]').textContent = item?.description || (commerce ? 'Elige el volumen de tu catálogo.' : 'Selecciona tu proyecto para ver la inversión.');
        this.querySelector('[data-support-detail]').hidden = field('support').value !== 'monthly';
      };
      button.disabled = !validPhone;
      if (!validPhone) {
        error.textContent = 'El WhatsApp de contacto aún no está configurado. Revisa el número en los ajustes de esta sección.';
        error.hidden = false;
      }
      field('inspiration').addEventListener('input', () => field('inspiration').setCustomValidity(''));
      field('client').addEventListener('input', () => field('client').setCustomValidity(''));
      form.addEventListener('change', update);
      form.addEventListener('submit', event => {
        event.preventDefault();
        field('client').setCustomValidity(clean(field('client').value) ? '' : 'Escribe tu nombre.');
        if (!form.reportValidity() || !validPhone) return;
        const inspiration = field('inspiration');
        if (inspiration.value.trim()) {
          let valid = false;
          try { valid = ['https:', 'http:'].includes(new URL(inspiration.value.trim()).protocol); } catch (_) {}
          inspiration.setCustomValidity(valid ? '' : 'Pega un enlace completo que empiece con https:// o http://.');
          if (!inspiration.reportValidity()) return;
        }
        const item = selected();
        if (!item) return;
        const commerce = field('project').value === 'commerce';
        const maintenance = packages.get('maintenance');
        const message = [
          'Hola, Hello Corp. Quiero cotizar mi proyecto web.',
          '',
          `Nombre: ${clean(field('client').value)}`,
          clean(field('brand').value) ? `Marca o negocio: ${clean(field('brand').value)}` : '',
          `Proyecto: ${commerce ? 'Tienda en línea' : (packages.get('landing').title || 'Landing / Web informativa')}`,
          commerce ? `Catálogo: ${volume.options[volume.selectedIndex].text}` : '',
          `Inversión base estimada: ${item.price}`,
          `Tiempo estimado: ${item.time}`,
          `Seguimiento: ${field('support').value === 'monthly' ? `Revisar mantenimiento después de los 2 meses incluidos (${maintenance.price})` : 'Solo los 2 meses iniciales incluidos, sin mensualidad'}`,
          clean(field('assets').value) ? `Ya tengo: ${clean(field('assets').value)}` : '',
          field('inspiration').value.trim() ? `Sitio de inspiración: ${field('inspiration').value.trim()}` : '',
          clean(field('details').value) ? `Sobre el proyecto: ${clean(field('details').value)}` : '',
          '',
          'Quiero revisar el alcance, los materiales y el siguiente paso. Entiendo que Shopify, dominio y apps se pagan por separado, y que el mantenimiento mensual es opcional.'
        ].filter(line => line !== '').join('\n');
        const url = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
        const opened = window.open(url, '_blank');
        if (opened) opened.opener = null;
        else window.location.assign(url);
      });
      if (this.dataset.locked === 'true') {
        const lockForm = this.querySelector('[data-unlock]');
        const content = this.querySelector('[data-content]');
        const lock = this.querySelector('[data-lock]');
        const key = 'hwf-access-' + this.id;
        const unlock = () => { content.hidden = false; lock.hidden = true; };
        try { if (sessionStorage.getItem(key) === 'true') unlock(); } catch (_) {}
        lockForm?.addEventListener('submit', event => {
          event.preventDefault();
          const input = lockForm.querySelector('input');
          if (input.value === this.dataset.password) {
            unlock();
            try { sessionStorage.setItem(key, 'true'); } catch (_) {}
            field('client').focus();
          } else {
            this.querySelector('[data-lock-error]').hidden = false;
            input.value = '';
            input.focus();
          }
        });
      }
      update();
    }
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kgrill2"] && !Shopify.designMode) return;
  try {
    
(()=>{
 const instances=new Map();
 function init(root){
  if(instances.has(root))return;
  const originalParent=root.parentElement;
  document.body.appendChild(root);
  document.documentElement.classList.add('kg-locked');
  const abort=new AbortController(),opts={signal:abort.signal};
  const dialog=root.querySelector('.kg-lightbox'),large=dialog.querySelector('img');
  root.querySelectorAll('[data-kg-photo]').forEach(button=>button.addEventListener('click',()=>{large.src=button.dataset.kgPhoto;large.alt=button.querySelector('img').alt;dialog.showModal()},opts));
  dialog.querySelector('.kg-close').addEventListener('click',()=>dialog.close(),opts);
  dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close()},opts);
  const reduced=matchMedia('(prefers-reduced-motion: reduce)');

  root.classList.toggle('kg-motion',!reduced.matches);
  const heroSection=root.querySelector('.kg-hero');
  let heroFrame=0;
  const updateHero=()=>{heroFrame=0;const progress=Math.min(1,Math.max(0,root.scrollTop/Math.max(heroSection.offsetHeight,1)));root.classList.toggle('kg-top-scrolled',root.scrollTop>60);if(!reduced.matches){heroSection.style.setProperty('--hero-shift',(progress*65)+'px');heroSection.style.setProperty('--hero-scale',String(1.04-progress*.04))}};
  root.addEventListener('scroll',()=>{if(!heroFrame)heroFrame=requestAnimationFrame(updateHero)},{...opts,passive:true});updateHero();
  root.querySelector('[data-kg-discover]')?.addEventListener('click',()=>root.querySelector('.kg-intro').scrollIntoView({behavior:reduced.matches?'instant':'smooth',block:'start'}),opts);
  const revealObserver=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-visible');revealObserver.unobserve(entry.target)}}),{root,threshold:.12});
  root.querySelectorAll('.kg-intro h2,.kg-bbq-copy,.kg-food>h2,.kg-dish,.kg-reels>div:first-child,.kg-drinks-copy,.kg-plan-grid article,.kg-gallery-heading').forEach((node,index)=>{node.classList.add('kg-reveal');node.style.transitionDelay=(index%3)*65+'ms';if(!reduced.matches)revealObserver.observe(node)});
  const videos=[...root.querySelectorAll('video')];
  const manuallyPaused=new WeakSet();
  const io=new IntersectionObserver(entries=>{entries.forEach(({target,intersectionRatio})=>{if(intersectionRatio>.3&&!root.querySelector('.kg-menu-dialog')?.open&&!document.hidden&&!reduced.matches&&!manuallyPaused.has(target)){target.play().catch(()=>{})}else target.pause()})},{root,threshold:[0,.3,.5]});
  videos.forEach(video=>{
   video.muted=true;video.playsInline=true;
   if(reduced.matches){video.pause();video.removeAttribute('autoplay')}
   const frame=video.closest('.kg-reel-frame')||video.parentElement;
   const pause=frame.querySelector('[data-kg-pause],.kg-video-toggle');
   const sound=frame.querySelector('[data-kg-sound]');
   const sync=()=>{if(pause){pause.textContent=video.paused?'Reproducir':'Pausar';pause.setAttribute('aria-label',pause.textContent+' video')}};
   pause?.addEventListener('click',()=>{if(video.paused){manuallyPaused.delete(video);video.play().catch(()=>{})}else{manuallyPaused.add(video);video.pause()}},opts);
   sound?.addEventListener('click',()=>{video.muted=!video.muted;if(!video.muted)videos.forEach(other=>{if(other!==video)other.muted=true});sound.textContent=video.muted?'Activar sonido':'Silenciar'},opts);
   video.addEventListener('play',sync,opts);video.addEventListener('pause',sync,opts);sync();io.observe(video);
  });
  document.addEventListener('visibilitychange',()=>{videos.forEach(video=>{if(document.hidden)video.pause();else{const rect=video.getBoundingClientRect();if(rect.top<innerHeight&&rect.bottom>0&&!reduced.matches&&!manuallyPaused.has(video))video.play().catch(()=>{})}})},opts);

  const menu=root.querySelector('.kg-menu-dialog');
  const normalize=value=>value.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
  const tabs=[...menu.querySelectorAll('[data-kg-menu-category]')];
  const categories=[...menu.querySelectorAll('[data-kg-category]')];
  const search=menu.querySelector('.kg-menu-search');let active='0';
  const selector=menu.querySelector('[data-kg-menu-select]');
  const resultCount=menu.querySelector('.kg-results');
  const groupOf=id=>id==='0'?'buffet':id==='15'?'desserts':['1','2','3'].includes(id)?'food':'drinks';
  const firstCategory={buffet:'0',food:'1',drinks:'4',desserts:'15'};
  const revealCategory=()=>{if(!menu.open)return;const tab=tabs.find(tab=>tab.dataset.kgMenuCategory===active);const strip=menu.querySelector('.kg-menu-categories');if(tab&&strip&&!search.value.trim())strip.scrollTo({left:tab.offsetLeft-strip.offsetLeft-(strip.clientWidth-tab.offsetWidth)/2,behavior:reduced.matches?'instant':'smooth'})};
  const mobileMenu=matchMedia('(max-width:899px)');
  const panels=menu.querySelector('.kg-menu-panels');
  const menuBody=menu.querySelector('.kg-menu-body');
  let fromSwipe=false;
  let swipeTimer;
  let movingTo=null;
  const syncSwipe=(move=true)=>{
   const swipe=mobileMenu.matches&&!search.value.trim();
   menu.classList.toggle('kg-swipe-mode',swipe);
   const index=categories.findIndex(category=>category.dataset.kgCategory===active);
   const title=tabs.find(tab=>tab.dataset.kgMenuCategory===active)?.textContent||'';
   menu.querySelector('[data-kg-swipe-name]').textContent=title+' · '+(index+1)+' / '+categories.length;
   if(swipe&&move&&menu.open&&index>=0){movingTo=index;panels.scrollTo({left:index*panels.clientWidth,behavior:reduced.matches?'instant':'smooth'});clearTimeout(swipeTimer);swipeTimer=setTimeout(()=>{movingTo=null},700)}
  };
  const filter=()=>{const query=normalize(search.value.trim());let total=0;categories.forEach(category=>{let visible=0;category.querySelectorAll('[data-kg-search]').forEach(item=>{item.hidden=!!query&&!normalize(item.dataset.kgSearch).includes(query);if(!item.hidden)visible++});category.hidden=query?visible===0:category.dataset.kgCategory!==active;if(!category.hidden)total+=visible});tabs.forEach(tab=>tab.setAttribute('aria-pressed',String(!query&&tab.dataset.kgMenuCategory===active)));selector.value=active;const current=groupOf(active);menu.querySelectorAll('[data-kg-menu-group]').forEach(button=>button.setAttribute('aria-pressed',String(!query&&button.dataset.kgMenuGroup===current)));[...selector.options].forEach(option=>option.hidden=groupOf(option.value)!==current);selector.closest('label').hidden=current==='buffet'||current==='desserts';resultCount.textContent=query?total+' resultados':'';menu.querySelector('.kg-menu-empty').hidden=total>0;const move=!fromSwipe;requestAnimationFrame(()=>{revealCategory();syncSwipe(move)})};
  panels.addEventListener('scroll',()=>{
   if(!menu.classList.contains('kg-swipe-mode')||!panels.clientWidth)return;
   clearTimeout(panels.kgSettle);
   panels.kgSettle=setTimeout(()=>{
    const index=Math.max(0,Math.min(categories.length-1,Math.round(panels.scrollLeft/panels.clientWidth)));
    if(movingTo!==null&&index!==movingTo)return;
    movingTo=null;
    const next=categories[index].dataset.kgCategory;
    if(next!==active){active=next;fromSwipe=true;filter();fromSwipe=false}
   },90);
  },opts);
  panels.addEventListener('pointerdown',()=>{movingTo=null;clearTimeout(swipeTimer)},opts);
  panels.addEventListener('touchstart',()=>{movingTo=null;clearTimeout(swipeTimer)},{...opts,passive:true});
  mobileMenu.addEventListener('change',()=>{filter();requestAnimationFrame(()=>syncSwipe(true))},opts);
  window.addEventListener('resize',()=>{if(menu.open)syncSwipe(true)},opts);
  menu.querySelectorAll('[data-kg-menu-group]').forEach(button=>button.addEventListener('click',()=>{active=firstCategory[button.dataset.kgMenuGroup];search.value='';filter();menu.querySelector('.kg-menu-body').scrollTop=0},opts));
  selector.addEventListener('change',()=>{active=selector.value;search.value='';filter();menu.querySelector('.kg-menu-body').scrollTop=0},opts);
  root.querySelectorAll('[data-kg-dish]').forEach(dish=>{
   const animate=()=>{dish.classList.remove('is-touched');void dish.offsetWidth;dish.classList.add('is-touched')};
   dish.addEventListener('pointerdown',animate,opts);
   const open=()=>{animate();search.value=dish.querySelector('h3').textContent.replace('Mandu Ramen','Mandu Ramyeon');if(search.value==='Mandu')search.value='Gogi Mandu';filter();filter();videos.forEach(video=>video.pause());menu.showModal();requestAnimationFrame(()=>syncSwipe(true));requestAnimationFrame(revealCategory);menu.querySelector('.kg-menu-body').scrollTop=0};
   dish.addEventListener('click',open,opts);dish.addEventListener('keydown',event=>{if(event.key==='Enter'||event.key===' '){event.preventDefault();open()}},opts);
  });
  filter();
  root.querySelectorAll('[data-kg-menu-open]').forEach(button=>button.addEventListener('click',()=>{if(button.dataset.kgMenuChoice){active=button.dataset.kgMenuChoice;search.value='';filter();menu.querySelector('.kg-menu-body').scrollTop=0}filter();videos.forEach(video=>video.pause());menu.showModal()},opts));
  menu.addEventListener('close',()=>{videos.forEach(video=>{const rect=video.getBoundingClientRect();if(rect.top<innerHeight&&rect.bottom>0&&!reduced.matches&&!manuallyPaused.has(video))video.play().catch(()=>{})})},opts);
  menu.querySelector('.kg-menu-close').addEventListener('click',()=>menu.close(),opts);
  menu.addEventListener('click',event=>{if(event.target===menu){const rect=menu.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)menu.close()}},opts);
  tabs.forEach(tab=>tab.addEventListener('click',()=>{active=tab.dataset.kgMenuCategory;search.value='';filter();menu.querySelector('.kg-menu-body').scrollTop=0},opts));
  search.addEventListener('input',filter,opts);
  root.querySelectorAll('a[href^="#kg-"]').forEach(a=>a.addEventListener('click',event=>{const target=root.querySelector(a.getAttribute('href'));if(target){event.preventDefault();target.scrollIntoView({behavior:reduced.matches?'instant':'smooth',block:'start'})}},opts));
  const cleanup=()=>{cancelAnimationFrame(heroFrame);revealObserver.disconnect();clearTimeout(swipeTimer);clearTimeout(panels.kgSettle);abort.abort();if(dialog.open)dialog.close();if(menu.open)menu.close();io.disconnect();videos.forEach(video=>video.pause());instances.delete(root);if(!instances.size)document.documentElement.classList.remove('kg-locked');root.remove()};
  instances.set(root,{cleanup,parent:originalParent});
 }
 document.querySelectorAll('[data-kg-root]').forEach(init);
 document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-kg-root]').forEach(init));
 document.addEventListener('shopify:section:unload',event=>{[...instances].forEach(([root,state])=>{if(event.target===state.parent||event.target.contains(state.parent))state.cleanup()})});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["megahome"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hello-corp-studio')) {
  customElements.define('hello-corp-studio', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.initFrame = requestAnimationFrame(() => this.init());
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observers?.forEach(observer => observer.disconnect());
      cancelAnimationFrame(this.initFrame);
      cancelAnimationFrame(this.scrollFrame);
      cancelAnimationFrame(this.portfolioFrame);
      this.movePortfolio = null;
      if (this.idleHandle && 'cancelIdleCallback' in window) cancelIdleCallback(this.idleHandle);
      clearTimeout(this.warmTimer);
      clearTimeout(this.showcaseTimer);
      clearTimeout(this.showcaseScrollTimer);
      this.focusShowcaseService = null;
      this.querySelectorAll('video').forEach(video => video.pause());
      this.querySelector('dialog[open]')?.close();
      this.controller = null;
    }
    init() {
      if (!this.isConnected) return;
      this.form = this.querySelector('[data-project-form]');
      if (!this.form) return;
      this.signal = this.controller.signal;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.hero = this.querySelector('[data-hero-video]');
      this.heroSection = this.querySelector('.hc3-hero');
      this.builder = this.querySelector('[data-builder]');
      this.caseBox = this.querySelector('[data-case]');
      this.stages = [...this.querySelectorAll('[data-stage]')];
      this.serviceButtons = [...this.querySelectorAll('.hc3-service-choice')];
      this.groups = [...this.querySelectorAll('[data-format-group]')];
      this.observers = [];
      this.manuallyPaused = new WeakSet();
      this.step = 0;
      this.service = null;
      this.selection = null;
      this.setAttribute('ready','');
      const params = new URLSearchParams(location.search);
      this.campaign = {};
      ['utm_source','utm_medium','utm_campaign','utm_content','utm_term'].forEach(key => {
        const value = params.get(key);
        if (value) this.campaign[key] = value.slice(0,160);
      });
      const intent = params.get('servicio') || this.dataset.intent;
      if (this.serviceButtons.some(button => button.dataset.service === intent)) {
        this.chooseService(intent, false);
        this.showStep(1, false);
      }
      this.addEventListener('click', event => this.onClick(event), {signal:this.signal});
      this.form.addEventListener('submit', event => {
        event.preventDefault();
        if (this.step < 2) this.next();
        else if (this.step === 2) this.querySelector('[data-direct-submit]').click();
      }, {signal:this.signal});
      this.form.addEventListener('change', event => {
        if (event.target.name === 'format') {
          this.selection = event.target;
          this.querySelector('[data-format-error]').hidden = true;
          this.setSelection();
          this.focusShowcaseService?.(this.service.dataset.service);
        }
        if (this.selection) this.prepareReview();
      }, {signal:this.signal});
      this.form.addEventListener('input', () => {
        if (this.selection) this.prepareReview();
      }, {signal:this.signal});
      this.caseBox.addEventListener('click', event => {
        if (event.target === this.caseBox) this.closeCase();
      }, {signal:this.signal});
      this.caseBox.addEventListener('close', () => {
        if (this.returnCaseFocus && this.caseOpener?.isConnected) this.caseOpener.focus({preventScroll:true});
      }, {signal:this.signal});
      this.startMedia();
      this.startShowcase();
      this.startPortfolio();
      this.observeVisibility();
      this.removeLegacyIntro();
      const warm = () => this.querySelectorAll('img[src]').forEach(img => {
        if (img.decode) img.decode().catch(() => {});
      });
      if ('requestIdleCallback' in window) this.idleHandle = requestIdleCallback(warm, {timeout:2000});
      else this.warmTimer = setTimeout(warm, 1200);
    }
    track(event,service=this.service?.dataset.service || 'all') {
      this.dispatchEvent(new CustomEvent('hello:conversion',{bubbles:true,detail:{event,service,section:this.id}}));
    }
    removeLegacyIntro() {
      document.querySelectorAll('.hc-welcome-auto').forEach(intro => {
        intro.hidden = true;
        intro.setAttribute('aria-hidden','true');
      });
      [...document.documentElement.classList].filter(name => name.startsWith('hc-welcome-preload-')).forEach(name => document.documentElement.classList.remove(name));
      document.body.classList.remove('hc-welcome-auto-lock');
    }
    onClick(event) {
      const button = event.target.closest('button,a');
      if (!button || !this.contains(button)) return;
      if (button.hasAttribute('data-service')) {
        event.preventDefault();
        this.chooseService(button.dataset.service);
        this.track('visual_service_select');
      } else if (button.hasAttribute('data-start')) {
        event.preventDefault();
        if (button.dataset.start) this.chooseService(button.dataset.start);
        else this.scrollBuilder();
        this.track('visual_brief_open');
      } else if (button.hasAttribute('data-direct-submit')) {
        if (!this.validDetails()) { event.preventDefault(); return; }
        this.prepareReview();
        button.href = this.querySelector('[data-whatsapp]').href;
        this.track('whatsapp_open');
      } else if (button.hasAttribute('data-next')) {
        this.next();
      } else if (button.hasAttribute('data-back')) {
        this.showStep(Math.max(0,this.step-1));
      } else if (button.hasAttribute('data-edit-format')) {
        this.showStep(1);
      } else if (button.hasAttribute('data-sound')) {
        this.hero.muted = !this.hero.muted;
        if (this.hero.paused) this.hero.play().catch(() => {});
        this.updateHeroControls();
      } else if (button.hasAttribute('data-play-toggle')) {
        this.toggleVideo(this.hero);
      } else if (button.hasAttribute('data-work-play')) {
        this.toggleVideo(button.closest('figure').querySelector('video'));
      } else if (button.hasAttribute('data-rail-next') || button.hasAttribute('data-rail-prev')) {
        const name = button.dataset.railNext || button.dataset.railPrev;
        const rail = [...this.querySelectorAll('[data-rail]')].find(item => item.dataset.rail === name);
        if (name === 'projects' && this.movePortfolio) this.movePortfolio(button.hasAttribute('data-rail-prev')?-1:1);
        else if (rail) rail.scrollBy({left:rail.clientWidth*.78*(button.hasAttribute('data-rail-prev')?-1:1),behavior:this.motion.matches?'instant':'smooth'});
      } else if (button.hasAttribute('data-whatsapp')) {
        if (!this.validDetails()) {
          event.preventDefault();
          this.showStep(2);
          return;
        }
        this.prepareReview();
        this.track('whatsapp_open');
      } else if (button.hasAttribute('data-project')) {
        this.openCase(button);
      } else if (button.hasAttribute('data-close')) {
        this.closeCase();
      } else if (button.hasAttribute('data-case-start')) {
        const service = this.caseService;
        this.returnCaseFocus = false;
        this.caseBox.close();
        this.chooseService(service);
      }
    }
    chooseService(id,advance=true) {
      const service = this.serviceButtons.find(button => button.dataset.service === id);
      const group = this.groups.find(group => group.dataset.formatGroup === id);
      if (!service || !group) return;
      this.service = service;
      this.groups.forEach(item => {
        item.disabled = item !== group;
        item.hidden = item !== group;
      });
      this.selection = group.querySelector('input:checked');
      this.querySelector('[data-service-title]').textContent = service.dataset.serviceLabel;
      this.querySelector('[data-format-title]').textContent = group.dataset.question;
      this.querySelector('[data-format-error]').hidden = true;
      if (this.selection) this.setSelection();
      if (advance) {
        this.focusShowcaseService?.(id);
        this.showStep(1);
      }
    }
    showStep(step,scroll=true) {
      this.step = step;
      this.stages.forEach((stage,index) => {
        stage.hidden = index !== step;
        stage.classList.toggle('hc3-stage-enter',index === step && !this.motion.matches);
      });
      this.querySelectorAll('[data-progress-step]').forEach((item,index) => {
        item.classList.toggle('is-current',index === step);
        item.classList.toggle('is-complete',index < step);
        if (index === step) item.setAttribute('aria-current','step');
        else item.removeAttribute('aria-current');
      });
      if (scroll) this.scrollBuilder();
    }
    scrollBuilder() {
      cancelAnimationFrame(this.scrollFrame);
      this.scrollFrame = requestAnimationFrame(() => {
        const rect = this.builder.getBoundingClientRect();
        if (rect.top < 0 || rect.top > innerHeight * .45) this.builder.scrollIntoView({behavior:this.motion.matches?'instant':'smooth',block:'start'});
        const title = this.stages[this.step].querySelector('h1,h2');
        if (title) {
          title.setAttribute('tabindex','-1');
          title.focus({preventScroll:true});
        }
      });
    }
    setSelection() {
      const selected = this.selection;
      if (!selected) return;
      const image = this.querySelector('[data-selected-image]');
      image.src = selected.dataset.formatImage;
      image.alt = selected.dataset.formatLabel;
      this.querySelector('[data-selected-service]').textContent = this.service.dataset.serviceLabel;
      this.querySelector('[data-selected-format]').textContent = selected.dataset.formatLabel;
      this.querySelector('[data-selected-price]').textContent = selected.dataset.formatPrice;
      const catalog = selected.value === 'web-1';
      this.querySelector('[data-catalog]').hidden = !catalog;
      this.form.elements.namedItem('catalog').disabled = !catalog;
    }
    startShowcase() {
      const showcase = this.querySelector('[data-showcase]');
      const rail = showcase?.querySelector('[data-showcase-rail]');
      if (!rail) return;
      const slides = [...rail.querySelectorAll('[data-showcase-slide]')];
      const toggle = showcase.querySelector('[data-showcase-toggle]');
      const counter = showcase.querySelector('[data-showcase-count]');
      let index = Math.max(0,slides.findIndex(slide => slide.dataset.start === this.service?.dataset.service));
      let direction = 1, hovered = false, focused = false, visible = true;
      let paused = this.motion.matches;
      const update = () => {
        index = Math.max(0, Math.min(slides.length - 1, Math.round(rail.scrollLeft / rail.clientWidth)));
        slides.forEach((slide,i) => { slide.inert = i !== index; });
        counter.textContent = String(index+1).padStart(2,'0')+' / '+String(slides.length).padStart(2,'0');
        showcase.dataset.currentService = slides[index].dataset.start;
      };
      const move = next => {
        const target = Math.max(0, Math.min(slides.length - 1, next));
        rail.scrollTo({left:target*rail.clientWidth,behavior:this.motion.matches?'instant':'smooth'});
      };
      const schedule = () => {
        clearTimeout(this.showcaseTimer);
        if (paused || hovered || focused || !visible || document.hidden) return;
        this.showcaseTimer = setTimeout(() => {
          if (index === slides.length-1) direction = -1;
          if (index === 0) direction = 1;
          move(index+direction);
          schedule();
        },4200);
      };
      const updateToggle = () => {
        toggle.textContent = paused?'▶':'Ⅱ';
        toggle.setAttribute('aria-pressed',String(paused));
        toggle.setAttribute('aria-label',paused?toggle.dataset.playLabel:toggle.dataset.pauseLabel);
      };
      this.focusShowcaseService = id => {
        const target = slides.findIndex(slide => slide.dataset.start === id);
        if (target < 0) return;
        paused = true;
        updateToggle();schedule();move(target);
      };
      rail.addEventListener('scroll',() => {
        clearTimeout(this.showcaseScrollTimer);
        this.showcaseScrollTimer = setTimeout(update,100);
      },{passive:true,signal:this.signal});
      showcase.addEventListener('pointerenter',event => {
        if (event.pointerType !== 'mouse') return;
        hovered=true;schedule();
      },{signal:this.signal});
      showcase.addEventListener('pointerleave',() => {hovered=false;schedule();},{signal:this.signal});
      showcase.addEventListener('focusin',event => {focused=event.target.matches(':focus-visible');schedule();},{signal:this.signal});
      showcase.addEventListener('focusout',event => {
        focused=showcase.contains(event.relatedTarget) && event.relatedTarget.matches(':focus-visible');schedule();
      },{signal:this.signal});
      rail.addEventListener('pointerdown',() => clearTimeout(this.showcaseTimer),{passive:true,signal:this.signal});
      rail.addEventListener('pointerup',schedule,{passive:true,signal:this.signal});
      rail.addEventListener('pointercancel',schedule,{passive:true,signal:this.signal});
      showcase.querySelector('[data-showcase-previous]').addEventListener('click',() => {move(index-1);schedule();},{signal:this.signal});
      showcase.querySelector('[data-showcase-next]').addEventListener('click',() => {move(index+1);schedule();},{signal:this.signal});
      toggle.addEventListener('click',() => {paused=!paused;if(!paused)focused=false;updateToggle();schedule();},{signal:this.signal});
      document.addEventListener('visibilitychange',schedule,{signal:this.signal});
      window.addEventListener('resize',() => {rail.scrollTo({left:index*rail.clientWidth,behavior:'instant'});update();},{signal:this.signal});
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          visible=entries[0].isIntersecting;schedule();
        },{threshold:.1});
        observer.observe(showcase);this.observers.push(observer);
      }
      rail.scrollTo({left:index*rail.clientWidth,behavior:'instant'});
      update();updateToggle();schedule();
    }
    next() {
      if (this.step === 1) {
        const group = this.groups.find(item => !item.disabled);
        this.selection = group?.querySelector('input:checked');
        if (!this.selection) {
          this.querySelector('[data-format-error]').hidden = false;
          group?.querySelector('input').focus({preventScroll:true});
          return;
        }
        this.setSelection();
        this.showStep(2);
        this.track('visual_format_select');
      } else if (this.step === 2) {
        if (!this.validDetails()) return;
        this.querySelector('[data-direct-submit]').click();
      }
    }
    validDetails() {
      for (const name of ['name','brand']) {
        const input = this.form.elements.namedItem(name);
        input.value = input.value.trim();
        if (!input.reportValidity()) return false;
      }
      return Boolean(this.service && this.selection);
    }
    prepareReview() {
      const get = name => this.form.elements.namedItem(name).value.trim();
      const image = this.querySelector('[data-review-image]');
      image.src = this.selection.dataset.formatImage;
      image.alt = this.selection.dataset.formatLabel;
      this.querySelector('[data-review-service]').textContent = this.service.dataset.serviceLabel;
      this.querySelector('[data-review-format]').textContent = this.selection.dataset.formatLabel;
      const values = {
        name:get('name'),brand:get('brand'),goal:get('goal') || this.dataset.copyDefaultGoal,
        budget:get('budget') || this.form.elements.namedItem('budget').options[0].textContent,
        when:get('when')
      };
      for (const [key,value] of Object.entries(values)) this.querySelector('[data-review-'+key+']').textContent = value;
      let phone = (this.dataset.phone || '').replace(/\D/g,'');
      if (phone.length === 10) phone = '52'+phone;
      if (!/^\d{11,15}$/.test(phone)) phone = '523121905941';
      const lines = [
        '¡Hello! Quiero platicar de un proyecto.','',
        'Nombre: '+values.name,'Marca o negocio: '+values.brand,
        'Servicio: '+this.service.dataset.serviceLabel,
        'Lo que necesito: '+this.selection.dataset.formatLabel,
        'Referencia de inversión: '+this.selection.dataset.formatPrice,
        'Mi idea: '+values.goal,'Inversión en mente: '+values.budget,'Inicio: '+values.when
      ];
      if (this.selection.value === 'web-1') lines.push('Productos del catálogo: '+get('catalog'));
      const reference = [this.campaign.utm_source,this.campaign.utm_campaign,this.campaign.utm_content].filter(Boolean).join(' / ');
      if (reference) lines.push('','Referencia: '+reference);
      this.querySelector('[data-whatsapp]').href = 'https://wa.me/'+phone+'?text='+encodeURIComponent(lines.join('\n'));
      this.querySelector('[data-direct-submit]').href = this.querySelector('[data-whatsapp]').href;
    }
    startPortfolio() {
      const section = this.querySelector('.hc3-projects');
      const rail = section?.querySelector('[data-rail="projects"]');
      if (!rail) return;
      const cards = [...rail.querySelectorAll('.hc3-project')];
      const toggle = section.querySelector('[data-portfolio-toggle]');
      let paused = this.motion.matches, hovered = false, focused = false, visible = false;
      let position = rail.scrollLeft, direction = 1, last = 0, holdUntil = 0;
      const active = () => !paused && !hovered && !focused && visible && !document.hidden;
      const frame = time => {
        if (!active()) return;
        const delta = last?Math.min(time-last,50):0;
        last = time;
        const maximum = rail.scrollWidth-rail.clientWidth;
        if (time < holdUntil || this.caseBox.open) position = rail.scrollLeft;
        else if (maximum > 1) {
          position = Math.max(0,Math.min(maximum,position+direction*delta*.026));
          rail.scrollLeft = position;
          if (position >= maximum-.5) direction = -1;
          else if (position <= .5) direction = 1;
        }
        this.portfolioFrame = requestAnimationFrame(frame);
      };
      const schedule = () => {
        cancelAnimationFrame(this.portfolioFrame);
        last=0;position=rail.scrollLeft;
        if (active()) this.portfolioFrame=requestAnimationFrame(frame);
      };
      const setToggle = () => {
        toggle.textContent=paused?'▶':'Ⅱ';
        toggle.setAttribute('aria-pressed',String(paused));
        toggle.setAttribute('aria-label',paused?toggle.dataset.playLabel:toggle.dataset.pauseLabel);
      };
      this.movePortfolio = step => {
        const card=cards.find(item=>!item.hidden);
        holdUntil=performance.now()+5000;
        rail.scrollBy({left:step*((card?.getBoundingClientRect().width || rail.clientWidth*.75)+18),behavior:this.motion.matches?'instant':'smooth'});
      };
      section.querySelectorAll('[data-portfolio-filter]').forEach(button=>button.addEventListener('click',()=>{
        const filter=button.dataset.portfolioFilter;
        cards.forEach(card=>{card.hidden=filter!=='all' && card.dataset.portfolioKind!==filter;});
        section.querySelectorAll('[data-portfolio-filter]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));
        rail.scrollTo({left:0,behavior:'instant'});position=0;direction=1;holdUntil=performance.now()+2000;schedule();
      },{signal:this.signal}));
      toggle.addEventListener('click',()=>{paused=!paused;if(!paused)focused=false;setToggle();schedule();},{signal:this.signal});
      section.addEventListener('pointerenter',event=>{if(event.pointerType==='mouse'){hovered=true;schedule();}},{signal:this.signal});
      section.addEventListener('pointerleave',()=>{hovered=false;schedule();},{signal:this.signal});
      section.addEventListener('focusin',event=>{focused=event.target.matches(':focus-visible');schedule();},{signal:this.signal});
      section.addEventListener('focusout',event=>{focused=section.contains(event.relatedTarget) && event.relatedTarget.matches(':focus-visible');schedule();},{signal:this.signal});
      ['pointerdown','pointerup','pointercancel','wheel'].forEach(name=>rail.addEventListener(name,()=>{holdUntil=performance.now()+5000;},{passive:true,signal:this.signal}));
      document.addEventListener('visibilitychange',schedule,{signal:this.signal});
      if ('IntersectionObserver' in window) {
        const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;schedule();},{threshold:.1});
        observer.observe(section);this.observers.push(observer);
      } else {visible=true;}
      setToggle();schedule();
    }
    startMedia() {
      this.hero.muted = true;
      this.hero.defaultMuted = true;
      const revealReel = () => {
        if (this.hero.readyState >= 2 && this.hero.currentTime > .5) {
          this.hero.closest('.hc3-reel').classList.add('is-reel-ready');
          this.hero.removeEventListener('timeupdate',revealReel);
        }
      };
      this.hero.addEventListener('timeupdate',revealReel,{signal:this.signal});
      this.querySelectorAll('video').forEach(video => {
        video.addEventListener('play',() => this.updateVideoControls(video),{signal:this.signal});
        video.addEventListener('pause',() => this.updateVideoControls(video),{signal:this.signal});
      });
      if (this.motion.matches) {
        this.hero.pause();
        this.manuallyPaused.add(this.hero);
      } else this.hero.play().catch(() => this.updateHeroControls());
      this.updateHeroControls();
      const preloadWork = () => this.querySelectorAll('[data-work-video]').forEach(video => {
        video.preload = 'auto';
        if (video.paused && video.readyState < 2) video.load();
      });
      if (this.hero.readyState >= 3) preloadWork();
      else this.hero.addEventListener('canplay',preloadWork,{once:true,signal:this.signal});
    }
    toggleVideo(video) {
      if (video.paused) {
        this.manuallyPaused.delete(video);
        video.play().catch(() => this.updateVideoControls(video));
      } else {
        this.manuallyPaused.add(video);
        video.pause();
      }
    }
    updateVideoControls(video) {
      if (video === this.hero) this.updateHeroControls();
      else {
        const button = video.closest('figure').querySelector('[data-work-play]');
        if (button) button.textContent = video.paused?'▶':'Ⅱ';
      }
    }
    updateHeroControls() {
      this.querySelector('[data-sound-text]').textContent = this.hero.muted?this.dataset.copySoundOff:this.dataset.copySoundOn;
      this.querySelector('[data-sound]').setAttribute('aria-pressed',String(!this.hero.muted));
      this.querySelector('[data-sound]').setAttribute('aria-label',this.hero.muted?this.dataset.copyEnableSound:this.dataset.copyDisableSound);
      this.querySelector('[data-play-text]').textContent = this.hero.paused?this.dataset.copyPlay:this.dataset.copyPause;
      this.querySelector('[data-play-toggle]').setAttribute('aria-label',this.hero.paused?this.dataset.copyPlayVideo:this.dataset.copyPauseVideo);
    }
    observeVisibility() {
      if (!('IntersectionObserver' in window)) return;
      const videoObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const video = entry.target;
          if (entry.isIntersecting && !this.manuallyPaused.has(video) && !this.motion.matches) video.play().catch(() => {});
          else if (!entry.isIntersecting) video.pause();
        });
      },{threshold:.15});
      this.querySelectorAll('video').forEach(video => videoObserver.observe(video));
      this.observers.push(videoObserver);
      const dock = this.querySelector('[data-dock]');
      let heroVisible=true,builderVisible=false,endVisible=false;
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.target === this.heroSection) heroVisible=entry.isIntersecting;
          else if (entry.target === this.builder) builderVisible=entry.isIntersecting;
          else endVisible=entry.isIntersecting;
        });
        dock.hidden = heroVisible || builderVisible || endVisible;
      },{threshold:0});
      [this.heroSection,this.builder,this.querySelector('.hc3-end')].forEach(element => observer.observe(element));
      this.observers.push(observer);
    }
    openCase(button) {
      this.caseOpener=button;
      this.caseService=button.dataset.projectService;
      this.returnCaseFocus=true;
      this.querySelector('[data-case-title]').textContent=button.dataset.name;
      this.querySelector('[data-case-kind]').textContent=button.dataset.kind;
      this.querySelector('[data-case-description]').textContent=button.dataset.description;
      const image=this.querySelector('[data-case-image]');
      image.src=button.querySelector('img').currentSrc || button.querySelector('img').src;
      image.alt=button.dataset.name;
      const second=this.querySelector('[data-case-second]');
      second.hidden=!button.dataset.second;
      if(button.dataset.second){second.src=button.dataset.second;second.alt=button.dataset.name;}
      else second.removeAttribute('src');
      this.caseBox.showModal();
      this.caseBox.scrollTop=0;
      this.track('project_view',this.caseService);
    }
    closeCase() {
      this.returnCaseFocus=true;
      if(this.caseBox.open)this.caseBox.close();
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
